<template>
  <form 
    @submit.prevent="showConfirmation" 
    novalidate
    v-test="'form'"
  >
    <div 
      v-for="question in formTemplate.questions" 
      :key="question.id"
    >
      <label 
        v-if="question.question && formTemplate.formType !== 'contract'"
        :class="$style.question"
      >
        {{question.question}}
      </label>
      <div :class="$style.answer">
        <div
          v-if="question.questionType === 'paragraph'"
          v-html="question.options.join(' ')"
        />
        <div v-else-if="question.questionType === 'signature'">
          <b>{{ $store.getters.customerName }}</b> - {{$d(new Date(), 'date')}}
          <SignatureInput
            :value.sync="question.answer"
          />
        </div>
        <BaseSelect
          v-else-if="question.questionType === 'dropdown'"
          :value.sync="question.answer"
          :options="question.options"
          :selectLabel="$t('select_option')"
          v-test="'input'"
          v-testId="question.id"
        />
        <BaseRadio
          v-else-if="question.questionType === 'boolean'"
          :options="[
            {
              value: 'yes',
              label: $t('yes')
            },
            {
              value: 'no',
              label: $t('no')
            }
          ]"
          :value.sync="question.answer"
          v-test="'input'"
          v-testId="question.id"
        />
        <BaseCheckboxes
          v-else-if="question.questionType === 'checkbox'"
          :label="question.question"
          :options="question.options"
          :value.sync="question.answer"
          v-test="'input'"
          v-testId="question.id"
        />
        <BaseInput
          v-else
          :value.sync="question.answer"
          v-test="'input'"
          v-testId="question.id"
        />
      </div>
    </div>
    <BaseButton 
      v-test="'btn-submit'"
    >
      {{$t('submit')}}
    </BaseButton>
    <ConfirmationModal 
      v-if="showModal" 
      @close="closeConfirmation"
      @submit="submit"
    />
  </form>
</template>
<script>
import SignatureInput from '@/components/SignatureInput'
import ConfirmationModal from '@/components/ConfirmationModal'
import BaseInput from '@/components/BaseInput'
import BaseCheckboxes from '@/components/BaseCheckboxes'
import BaseButton from '@/components/BaseButton'
import BaseSelect from '@/components/BaseSelect'
import BaseRadio from '@/components/BaseRadio'

export default {
  components: {
    SignatureInput,
    ConfirmationModal,
    BaseInput,
    BaseCheckboxes,
    BaseButton,
    BaseSelect,
    BaseRadio
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    formTemplate() {
      return this.$store.getters.formTemplate
    }
  },
  methods: {
    showConfirmation() {
      this.showModal = true
    },
    closeConfirmation() {
      this.showModal = false;
    },
    submit() {
      this.$store.dispatch('saveFormSubmission');
      this.closeConfirmation()
    }
  },
}
</script>

<style lang="scss" module>
.question {
  display: inline-block;
  margin-bottom: $spacing / 4;
}

.answer {
  margin-bottom: $spacing;
}
</style>
